import GeaoLayout from "../shared/Layout/GeaoLayout";

export default function BackgroundCheckDenial() {
    /*TODO: If an different header or icon is ever needed create a useState for it*/
    return (
        <GeaoLayout header="Application Status">
            <div className="container">
                <>
                    <div className="container" style={{ paddingTop: '0', marginTop: '0' }}>
                        <div className="h3 mb-5">
                            We're unable to continue with your application.
                        </div>

                        <div className="h4 mb-3">
                            Unfortunately, you're not able to sell with GEICO.
                        </div>
                        <p className="mb-3">
                            GEICO For Your Agency requires that all applicants pass a background check.
                        </p>
                        <p className="mb-3">
                            Unfortunately, you are not eligible to sell with GEICO at this time due to your background check results. If you have any questions regarding the background check, you can{' '}
                            <a
                                href="https://www.hireright.com/services/group/criminal-background-services"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                contact HireRight
                            </a>.
                        </p>
                    </div>
                </>

            </div>
        </GeaoLayout>
    );
}